<template>
  <div style="position: relative">
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="container-xl" style="position: relative !important;">
      <!-- Loading Overlay -->
      <div v-if="loading" class="loading-overlay d-flex justify-content-center mb-3">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div class="border-0 text-container">
        <div v-if="groups.length >0">
          <div class="title-area">
            <h1 id="what-do-you-want-to-do" class="page-title">
              {{ screentexts[4]?screentexts[4].element_text:'' }}
            </h1>
          </div>
          
          <!-- Radio option A: Existing group -->
          <div class="form-group">
            <div class="form-check">
              <input 
                id="radio-existing-group"
                v-model="selected"
                class="form-check-input"
                type="radio"
                name="create-action"
                value="A"
              >
              <label class="form-check-label" for="radio-existing-group">
                <span id="existing-group">{{ screentexts[5]?screentexts[5].element_text:'Create a survey for one of my existing groups' }}</span>
              </label>
            </div>
            <select
              v-model="group_id"
              class="form-select select-css"
              :class="`${anon ? 'g-anon' : '' }`"
              @change="setradio('A')"
            >
              <option
                v-for="option in groups"
                :key="option.value"
                :value="option.value"
                :disabled="option.disabled"
              >
                {{ option.text }}
              </option>
            </select>
          </div>

          <!-- Radio option B: New group -->
          <div class="form-group">
            <div class="form-check">
              <input
                id="radio-new-group"
                v-model="selected"
                class="form-check-input"
                type="radio"
                name="create-action"
                value="B"
              >
              <label class="form-check-label" for="radio-new-group">
                <span id="new-group">{{ screentexts[6]?screentexts[6].element_text:'Create a survey for a new group' }}</span>
              </label>
            </div>
          </div>

          <!-- Radio option C: Checklist -->
          <div class="form-group">
            <div class="form-check">
              <input
                id="radio-checklist"
                v-model="selected"
                class="form-check-input"
                type="radio"
                name="checklist-action"
                value="C"
              >
              <label class="form-check-label" for="radio-checklist">
                <span id="checklist">Check if a group is a team</span>
              </label>
            </div>
          </div>
        </div>

        <!-- No groups message -->
        <div v-if="groups.length === 0">
          <h3 class="card-title">Create a new Survey</h3>
          <h5>You do not yet have any groups set up.</h5>
          <h5>
            In the following pages, you will be guided in setting up your group and creating a survey for the group<br><br>
            You can check if a group is a team and suitable for the GDQ questionnaire by running the Checklist function <a href="/checklist">here</a><br><br>
            To continue, click &quot;Next&quot;
          </h5>
          <input
            v-show="false"
            v-model="selected"
            type="hidden"
          >
        </div>

        <!-- Spacers -->
        <div class="row">
          &nbsp;
        </div>
        <div class="row" />
        
        <!-- Navigation buttons -->
        <div class="row">
          <div class="col-12">
            <router-link to="/" class="btn btn-secondary float-start">
              &lt;<span> Back</span>
            </router-link>
            
            <router-link
              v-if="selected === 'A' && group_id !== null"
              to="/create/group/survey"
              class="float-end"
            >
              <button class="btn btn-primary">
                <span>Next </span>&gt;
              </button>
            </router-link>
            
            <router-link
              v-if="selected === 'B'"
              to="/create/group"
              class="float-end"
            >
              <button class="btn btn-primary">
                <span>Next </span>&gt;
              </button>
            </router-link>
            
            <button
              v-if="selected === null || (selected === 'A' && group_id === null)"
              disabled
              class="btn btn-primary disabled float-end"
            >
              <span class="">Next </span>&gt;
            </button>
            
            <router-link
              v-if="selected === 'C'"
              to="/checklist"
              class="float-end"
            >
              <button class="btn btn-primary">
                <span>Next </span>&gt;
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'

export default {
  name: 'CreatePage',
  components: {
    Navbar,
    Breadcrumb
  },
  data () {
    return {
      screen_id: 2,
      screentexts: [],
      group_id: null,
      selected: null,
      loading: true,
      // Add a local groups array to track data loading
      local_groups: []
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    groups () {
      // Since the API filters for group_deleted = 0, we should only show groups where group_deleted is 0
      // The API returns group_deleted as string "0", but we need to be robust to different data types
      // Convert to number for comparison to handle string "0", integer 0, boolean false, etc.
      const items = this.$store.state.groups.filter(f => {
        return Number(f.group_deleted) === 0;
      })
      const groups = [{
        value: null,
        text: 'Select group',
        disabled: true
      }]
      for (let i = 0; i < items.length; i++) {
        const option = {
          value: items[i].id,
          text: items[i].group_name
        }
        groups.push(option)
      }
      return groups
    }
  },
  watch: {
    // Watch for changes in the store groups
    '$store.state.groups': {
      handler(newVal) {
        this.local_groups = newVal;
      },
      immediate: true,
      deep: true
    },
    groups () {
      if (this.groups.length === 0) { this.selected = 'B' } else { this.selected = 'A' }
    }
  },
  async created () {
    this.loading = true
    try {
      // Ensure groups are fetched before proceeding
      await this.$store.dispatch('groups_fetch')
      await this.screentexts_get()
      await this.$store.dispatch('group_clear')
      await this.$store.dispatch('survey_clear')
    } finally {
      this.loading = false
    }
  },
  async beforeRouteLeave (to, from, next) {
    this.loading = true
    // We are going forward - save
    if (to.name === 'creategroup') {
      // Clear group in state
      await this.$store.dispatch('group_clear')
    }
    if (to.name === 'creategroupsurvey') {
      // Load group to state
      await this.$store.dispatch('group_setcurrent', this.group_id)
    }
    next()
    this.loading = false
  },
  methods: {
    groups_get: async function () {
      await this.$store.dispatch('groups_fetch')
    },
    setradio (value) {
      this.selected = value
    },
    setselect () {
      this.group_id = null
    },
    screentexts_get: async function () {
      const screentexts = []
      const filter = {
        screen_id: {
          operator: '=',
          value: this.screen_id
        }
      }
      await this.$store.dispatch('systemscreenelements_fetch', { filter })
        .then((resp) => {
          const dbtexts = resp.data.result
          for (let i = 0; i < dbtexts.length; i++) {
            const screentext = {
              id: dbtexts[i].id,
              element_text: dbtexts[i].element_text,
              element_bubbletext: dbtexts[i].element_bubbletext
            }
            screentexts[dbtexts[i].id] = screentext
          }
          this.screentexts = screentexts
        })
    }
  }
}
</script>
<style scoped>
.gg-shape-triangle {
    position: relative;
    transform: scale(var(--ggs,1));
    width: 22px;
    height: 17px;
    border-left: 3px solid transparent;
    border-bottom: 3px solid
}
.gg-shape-triangle,
.gg-shape-triangle::before {
    display: block;
    box-sizing: border-box;
    border-right: 3px solid transparent
}
.gg-shape-triangle::before {
    content: "";
    position: absolute;
    width: 20px;
    height: 20px;
    border-left: 3px solid;
    border-top: 3px solid;
    border-bottom: 3px solid transparent;
    transform: rotate(45deg) skew(10deg,10deg);
    left: -2px;
    bottom: -13px
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* Ensure radio buttons align with heading - no indentation */
.form-group {
  padding-left: 0 !important;
  margin-left: 0 !important;
}

.form-check {
  padding-left: 0 !important;
  margin-left: 0 !important;
}
</style>
